module.exports = __webpack_public_path__ + "static/media/bottomContainer.f6b869ba.png";